import type { ReactNode } from "react";

export const GAIL_BLUE_TEXT_CLASS = "gail-blue-text";

export function GailBlue({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <span
      className={`${GAIL_BLUE_TEXT_CLASS} text-gail-primary !text-gail-primary [&_*]:!text-gail-primary`}
    >
      {children}
    </span>
  );
}
